// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"d40f6c26","453":"e67ae3a8","764":"ae6eb27c"}[chunkId] + ".chunk.js";
};